'use strict';

angular.module('studies')
    .controller('StudyUpdateFormController', ['$q', 'StudiesManager', 'ShareCrfApiErrorCodes', function($q, StudiesManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.ready = false;
        vm.deletedLogo = false;
        vm.logoImage = null;

        vm.$onInit = function() {
            vm.studyData = vm.study.get();

            vm.data = _.assign({
                passwordExpiration: vm.studyData.passwordExpiration,
            }, _.clone(vm.studyData.info));

            vm.error = false;
            vm.submitted = false;
            vm.running = false;

            vm.submit = function(form) {
                vm.submitted = true;

                var promise = $q.resolve();

                if (form.$valid) {
                    vm.running = true;

                    if (vm.deletedLogo && !vm.logoImage) {
                        promise = promise
                            .then(function() {
                                vm.data.logo = '';
                            });
                    }

                    promise = promise
                        .then(function() {
                            var editableFields = [
                                'name',
                                'acronym',
                                'startDate',
                                'protocolId',
                                'protocolType',
                                'investigator',
                                'summary',
                                'sponsor',
                                'studyType',
                                'logo',
                            ];
                            if (vm.studyData.info.license.features.studyPasswordExpiration) {
                                editableFields.push('passwordExpiration');
                            }
                            var payload = _.pick(vm.data, editableFields);
                            if (vm.logoImage) {
                                payload.logo = vm.logoImage;
                            }

                            return StudiesManager.update(vm.studyData.subdomain, payload);
                        })
                        .then(function() {
                            vm.running = false;

                            return vm.onSubmit();
                        })
                        .catch(function(error) {
                            vm.running = false;
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        });
                }

                return promise;
            };

            vm.deleteLogo = function() {
                vm.deletedLogo = true;
            };

            vm.ready = true;
        };

    }]);
